/** ECharts 统一基线配置 */
export const BASE_TOOLBOX = {
  feature: {
    dataZoom: {},
    restore: {},
    saveAsImage: {},
  },
};

export const BASE_DATAZOOM = [
  {
    type: 'slider' as const,
    bottom: 10,
  },
];

export function format2(n: number | string | null | undefined): string {
  const num = typeof n === 'number' ? n : Number(n);
  if (!Number.isFinite(num)) return '-';
  const fixed = num.toFixed(2);
  return fixed.endsWith('.00') ? fixed.slice(0, -3) : fixed;
}

/** 安全过滤 CSV 文件名中的非法字符 */
export function sanitizeFilename(name: string): string {
  return name.replace(/[<>:"\\/|?*\x00-\x1f]/g, '_').replace(/\.+/g, '.');
}
